module.exports = __webpack_public_path__ + "img/collection-diamondJewelryRedgold.cc71bb0.jpg";